import { gradeLabel } from '@/util/gradesort'
import type { FacetOptionSource } from '@/browse/browse_state'

export const GRADES = ['Birth-3', 'Pre-K', 'K', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', 'Adult-Transition']

export function gradeSources(grades: string[] = GRADES): FacetOptionSource[] {
  return grades.map((grade) => ({ value: grade, label: gradeLabel(grade) }))
}

export function sortGrades(grades: string[]): string[] {
  const rank = (grade: string) => {
    const index = GRADES.indexOf(grade)
    return index === -1 ? GRADES.length : index
  }
  return [...grades].sort((a, b) => rank(a) - rank(b))
}
